export default __webpack_public_path__ + "static/media/221.0881b46d.jpg";